import { RRule } from 'rrule'
import _ from 'lodash'
import moment from 'moment'
import { IdHelper } from './IdHelper'

const fixRRuleDate = (date) => {
  let dateone = moment(date).utc().format()
  let newdate = dateone.replace(/-/g, '').replace(/:/g, '')
  return newdate
}

const fixDayStr = (days) => {
  let strDay = ''
  _.forEach(days, (a) => {
    if (strDay === '') {
      strDay = a
    } else {
      strDay = `${strDay},${a}`
    }
  })
  console.log({ strDay: strDay })
  return strDay
}

export const MarketPlaceFreq = (startDate, EndDate, feqdata) => {
  let SVDates = []
  let date1 = fixRRuleDate(startDate)
  let date2 = fixRRuleDate(EndDate)
  for (var f in feqdata) {
    const visitDates = []
    const daystr = fixDayStr(feqdata[f].WeekDays)
    const visitNumber = feqdata[f].VisitNumber
    let ruleStr = `FREQ=WEEKLY;INTERVAL=1;COUNT=${visitNumber};DTSTART=${date1};UNTIL=${date2};WKST=MO;BYDAY=${daystr}`
    console.log({ ruleStr: ruleStr })
    const rule = RRule.fromString(ruleStr)
    const newdates = rule.all()
    _.forEach(newdates, (n) => {
      visitDates.push({ VisitDate: moment(n).startOf('day').format() })
    })
    const cloneVisitdates = _.clone(visitDates)
    feqdata[f].VisitDates = cloneVisitdates
    SVDates.push(feqdata[f])
    console.log({ dates: SVDates })
  }
  return SVDates
}

export const GenerateWeeklyFrequency = (feqdata) => {
  console.log({ feqdata })
  let date1 = fixRRuleDate(feqdata.StartDate)
  let date2 = fixRRuleDate(feqdata.EndDate)
  const visitDates = []
  const daystr = fixDayStr(feqdata.WeekDays)
  const visitNumber = feqdata.VisitCount
  let ruleStr = `FREQ=WEEKLY;INTERVAL=1;COUNT=${visitNumber};DTSTART=${date1};UNTIL=${date2};WKST=MO;BYDAY=${daystr}`
  console.log({ ruleStr })
  const rule = RRule.fromString(ruleStr)
  const newdates = rule.all()
  console.log({ newdates })

  _.forEach(newdates, (n) => {
    visitDates.push({
      _key: IdHelper.uuId(),
      Date: moment(n).utc().startOf('day').format(),
      StartTime: feqdata.StartTime,
      Duration: feqdata.Duration,
      AssignedToKey: feqdata.Employee,
      DisplayCardName: feqdata.DisplayCardName,
      StartTimeText: feqdata.Time,
      VisitSkills: feqdata.VisitSkills,
      SkillLevel: feqdata.SkillLevel || null,
      AgencyOffer: feqdata.AgencyOffer || null,
      Type: 'Regular'
    })
  })
  return visitDates
}

export const EpisodeFrequency = (freqParms) => {
  const rule = new RRule({
    freq: GetRRuleOccurence(freqParms.freq),
    interval: getInterval(freqParms.freq, freqParms.numberOfVisits),
    byweekday: buildweekDay(freqParms.daysOfTheWeek),
    count: freqParms.count,
    dtstart: moment(freqParms.start).toDate(),
    until: moment(freqParms.stop).toDate()
  })

  let ruleResult = {}

  ruleResult.Rule = rule
  ruleResult.VisitDates = rule.all()
  ruleResult.String = rule.toString()
  ruleResult.ReadableText = rule.toText()

  return ruleResult
}

export const rruleWeekDays = [
  { Text: 'Sunday', Value: 'SU' },
  { Text: 'Monday', Value: 'MO' },
  { Text: 'Tuesday', Value: 'TU' },
  { Text: 'Wednesday', Value: 'WE' },
  { Text: 'Thursday', Value: 'TH' },
  { Text: 'Friday', Value: 'FR' },
  { Text: 'Saturday', Value: 'SA' }
]

export const FrequencyWeeks = [
  { Text: '0', Value: 0 },
  { Text: '1', Value: 1 },
  { Text: '2', Value: 2 },
  { Text: '3', Value: 3 },
  { Text: '4', Value: 4 },
  { Text: '5', Value: 5 },
  { Text: '6', Value: 6 },
  { Text: '7', Value: 7 },
  { Text: '8', Value: 8 },
  { Text: '9', Value: 9 },
  { Text: '10', Value: 10 }
]

export const FrequencyOccurrence = [
  { Text: '0', Value: 0 },
  { Text: '1', Value: 1 },
  { Text: '2', Value: 2 },
  { Text: '3', Value: 3 },
  { Text: '4', Value: 4 },
  { Text: '5', Value: 5 },
  { Text: '6', Value: 6 }
]

export const FrequencyOccurrenceType = [
  { Text: 'Daily', Value: 'DAILY' },
  { Text: 'Weekly', Value: 'WEEKLY' },
  { Text: 'Monthly', Value: 'MONTHLY' }
]

export const GetRRuleOccurence = (o) => {
  let occurrence = RRule.WEEKLY

  switch (o) {
    case 'WEEKLY':
      occurrence = RRule.WEEKLY
      break
    case 'DAILY':
      occurrence = RRule.HOURLY
      break
    case 'MONTHLY':
      occurrence = RRule.MONTHLY
      break
  }
  return occurrence
}

const buildweekDay = (weekday) => {
  let weekDay = []

  _.map(weekday, (d) => {
    if (d === 'SU') {
      weekDay.push(RRule.SU)
    }
    if (d === 'MO') {
      weekDay.push(RRule.MO)
    }
    if (d === 'TU') {
      weekDay.push(RRule.TU)
    }
    if (d === 'WE') {
      weekDay.push(RRule.WE)
    }
    if (d === 'TH') {
      weekDay.push(RRule.TH)
    }
    if (d === 'FR') {
      weekDay.push(RRule.FR)
    }
    if (d === 'SA') {
      weekDay.push(RRule.SA)
    }
  })
  return weekDay
}

const getInterval = (occurrence, numberofvisits) => {
  let interval = 1

  switch (occurrence) {
    case 'WEEKLY':
    case 'MONTHLY':
      interval = 1
      break
    case 'DAILY':
      interval = (24 / _.parseInt(numberofvisits))
      break
  }

  return interval
}
